export default function smoothPan( map, position ) {
	const initialBounds = map.getBounds();
	const initialZoom = map.getZoom();
	const initialMinZoom = map.minZoom;
	const zoomOut = function() {
		return new Promise( resolve => {
			const zoomOutRepeater = setInterval( () => {
				const mapBounds = map.getBounds();

				if ( mapBounds.contains( position ) ) {
					clearInterval( zoomOutRepeater );

					setTimeout( resolve, 400 );
				} else {
					map.setZoom( map.getZoom() - 1 );
				}
			}, 100 );
		} );
	};
	const panTo = function() {
		return new Promise( resolve => {
			map.panTo( position );

			// Wait for the pan to finish
			setTimeout( resolve, 350 );
		} );
	};
	const zoomIn = function() {
		return new Promise( resolve => {
			const zoomInRepeater = setInterval( () => {
				const mapZoom = map.getZoom();

				if ( initialZoom > mapZoom ) {
					map.setZoom( mapZoom + 1 );
				} else {
					clearInterval( zoomInRepeater );

					setTimeout( resolve, 100 );
				}
			}, 100 );
		} );
	};

	map.minZoom = 1;

	return new Promise( resolve => {
		const finish = function() {
			map.minZoom = initialMinZoom;
			resolve();
		};

		if ( initialBounds.contains( position ) ) {
			panTo().then( finish );
		} else {
			zoomOut()
			.then( panTo )
			.then( zoomIn )
			.then( finish );
		}
	} );
}
